"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaMaskConnectionError = exports.EthereumProviderNotConnected = exports.EthereumProviderNotFound = exports.EthereumProvider = exports.EthereumNetwork = void 0;
var detect_provider_1 = __importDefault(require("@metamask/detect-provider"));
var web3_1 = __importDefault(require("web3"));
var ENS = require("ethjs-ens");
var EthereumNetwork;
(function (EthereumNetwork) {
    EthereumNetwork[EthereumNetwork["MAINNET"] = 1] = "MAINNET";
    EthereumNetwork[EthereumNetwork["RINKEBY"] = 4] = "RINKEBY";
})(EthereumNetwork = exports.EthereumNetwork || (exports.EthereumNetwork = {}));
var EthereumProviderNotConnected = /** @class */ (function (_super) {
    __extends(EthereumProviderNotConnected, _super);
    function EthereumProviderNotConnected(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = "EthereumProviderNotConnected";
        return _this;
    }
    return EthereumProviderNotConnected;
}(Error));
exports.EthereumProviderNotConnected = EthereumProviderNotConnected;
var EthereumProviderNotFound = /** @class */ (function (_super) {
    __extends(EthereumProviderNotFound, _super);
    function EthereumProviderNotFound(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = "EthereumProviderNotFound";
        return _this;
    }
    return EthereumProviderNotFound;
}(Error));
exports.EthereumProviderNotFound = EthereumProviderNotFound;
var EthereumProviderMultipleChains = /** @class */ (function (_super) {
    __extends(EthereumProviderMultipleChains, _super);
    function EthereumProviderMultipleChains(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = "EthereumProviderMultipleChains";
        return _this;
    }
    return EthereumProviderMultipleChains;
}(Error));
var MetaMaskConnectionError = /** @class */ (function (_super) {
    __extends(MetaMaskConnectionError, _super);
    function MetaMaskConnectionError(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = "MetaMaskConnectionError";
        return _this;
    }
    return MetaMaskConnectionError;
}(Error));
exports.MetaMaskConnectionError = MetaMaskConnectionError;
var ENSProviderNotFound = /** @class */ (function (_super) {
    __extends(ENSProviderNotFound, _super);
    function ENSProviderNotFound(message) {
        if (message === void 0) { message = undefined; }
        var _this = _super.call(this, message) || this;
        _this.name = "ENSProviderNotFound";
        return _this;
    }
    return ENSProviderNotFound;
}(Error));
/**
 * @dev EthereumProvider is a singleton that allows all apps to interact with the ethereum chain
 *
 * ALL COMPONENTS MUST USE THE SAME NETWORK!!!
 *
 * Every application/component that wishes to call web3 functions or access the wallet should
 * first subscribe to the ADDRESS_CHANGED and PROVIDER_CHANGED events, then call initialize.
 *
 * Every application/component MUST call initialize first.
 *
 * When you wish to perform any write operations, the application/component must call connect. This
 * will either result in an ADDRESS_CHANGED (and optionally PROVIDER_CHANGED) on success, OR it will
 * throw an EthereumProviderNotConnected failure (if metamask is not installed, if the network is defined without a
 * fallbackProvider and the wallet network is on the wrong chain, or if the user rejects the connection request.)
 *
 * After calling initialize, you will have a provider to the correct network (and usage of web3 to the right network).
 * However, this does NOT mean that the installed wallet is on the right network.  To check that, use the
 * chainIsCorrect function.
 *
 */
var _EthereumProvider = /** @class */ (function () {
    function _EthereumProvider() {
    }
    /**
     * Every class that uses EthereumProvider should call initialize
     * Will throw EthereumProviderNotFound if there is no ethereum provider available
     *
     * If you pass in network and fallbackWebsockethost, we assume that the fallbackWebsocketHost is
     * on the same network as the one desired
     *
     * @param network               - The network you wish to run on.  If false, there is no preference
     * @param fallbackWebsockethost - The fallbackWebsocketHost for a provider (useful for browsers with no metamask)
     */
    _EthereumProvider.initialize = function (network, fallbackWebsockethost) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(!this._browserChainId && window.ethereum != null && window.ethereum.isConnected())) return [3 /*break*/, 2];
                        _a = this;
                        _b = parseInt;
                        return [4 /*yield*/, window.ethereum.request({
                                method: "eth_chainId",
                            })];
                    case 1:
                        _a._browserChainId = _b.apply(void 0, [_c.sent()]);
                        _c.label = 2;
                    case 2:
                        // If network was already set, all networks must be the same
                        if (this._network && this._network != network)
                            throw new EthereumProviderMultipleChains("Only one chain can be used at a time.");
                        // Provider already set up, simply return
                        if (this._provider && this._ens)
                            return [2 /*return*/];
                        // Set network
                        this._network = network;
                        if (fallbackWebsockethost !== undefined) {
                            try {
                                new URL(fallbackWebsockethost);
                                // Use fallback websocket host if provided
                                this._fallbackProvider = new web3_1.default.providers.WebsocketProvider(fallbackWebsockethost, {
                                    timeout: 30000,
                                    clientConfig: {
                                        maxReceivedFrameSize: 100000000,
                                        maxReceivedMessageSize: 100000000,
                                        // Useful to keep a connection alive
                                        keepalive: true,
                                        keepaliveInterval: 20000 // ms
                                    },
                                    reconnect: {
                                        auto: true,
                                        delay: 5000,
                                        maxAttempts: 5,
                                        onTimeout: false
                                    },
                                });
                            }
                            catch (_d) {
                                console.warn('Fallback Provider has invalid URL');
                            }
                        }
                        if (window.ethereum != null) {
                            // Using web3 comatible browser with provider
                            this._browserProvider = window.ethereum;
                            this._addBrowserProviderListeners();
                        }
                        this._setProvider(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    // Add browser provider listeners
    _EthereumProvider._addBrowserProviderListeners = function () {
        var _this = this;
        // Add listeners
        //@ts-ignore
        this._browserProvider.on("connect", function (connectInfo) { _this._handleEthereumConnect(connectInfo); });
        //@ts-ignore
        this._browserProvider.on("accountsChanged", function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this._handleEthereumAccountChange()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        }); }); });
        //@ts-ignore
        this._browserProvider.on("chainChanged", function (chainId) { _this._handleEthereumChainChange(parseInt(chainId)); });
        //@ts-ignore
        this._browserProvider.on("disconnect", function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._selectedAddress = undefined;
                this._selectedENSName = undefined;
                window.dispatchEvent(new Event(this.ADDRESS_CHANGED));
                return [2 /*return*/];
            });
        }); });
    };
    // Set provider based on configured chain
    _EthereumProvider._setProvider = function (initialize) {
        if (initialize === void 0) { initialize = false; }
        this._ens = undefined;
        var providerChanged = false;
        if (this._browserProvider && (!this._network || this._browserChainId == this._network)) {
            if (this._provider != this._browserProvider) {
                this._provider = this._browserProvider;
                this._web3 = undefined;
                providerChanged = true;
            }
        }
        else if (this._fallbackProvider) {
            if (this._provider != this._fallbackProvider) {
                this._provider = this._fallbackProvider;
                this._web3 = undefined;
                providerChanged = true;
            }
        }
        else {
            if (this._browserProvider && (this._network && this._browserChainId != this._network)) {
                window.dispatchEvent(new Event(this.PROVIDER_CANT_CONNECT));
                if (initialize)
                    throw new EthereumProviderNotConnected();
            }
            window.dispatchEvent(new Event(this.PROVIDER_NOT_FOUND));
            if (initialize)
                throw new EthereumProviderNotFound("EthereumProvider not found");
        }
        // Set up ENS based on provider
        if (this._browserChainId && (!this._network || this._browserChainId == this._network)) {
            // Use browserProvider if valid
            this._ens = new ENS({ provider: this._browserProvider, network: this._browserChainId.toString() });
        }
        else if (this._fallbackProvider && this._network) {
            this._ens = new ENS({ provider: this._fallbackProvider, network: this._network.toString() });
        }
        // Dispatch event if provider changed
        if (providerChanged)
            window.dispatchEvent(new Event(this.PROVIDER_CHANGED));
    };
    /**
     * Handle ethereum connection
     */
    _EthereumProvider._handleEthereumConnect = function (connectInfo) {
        this._handleEthereumChainChange(parseInt(connectInfo.chainId));
    };
    /**
     * Handle ethereum chain changes
     */
    _EthereumProvider._handleEthereumChainChange = function (chainId) {
        // Chain change, you want to set up to use the right provider
        this._browserChainId = chainId;
        this._setProvider();
        window.dispatchEvent(new CustomEvent(this.CHAIN_CHANGED));
    };
    /**
     * Handle Ethereum account changes
     */
    _EthereumProvider._handleEthereumAccountChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newSelectedAddress, newSelectedENSName, accounts, accounts, error_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSelectedAddress = undefined;
                        newSelectedENSName = undefined;
                        if (!this._selectedAddress) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.web3().eth.getAccounts()];
                    case 1:
                        accounts = _a.sent();
                        if (accounts.length) {
                            newSelectedAddress = accounts[0];
                        }
                        return [3 /*break*/, 6];
                    case 2:
                        if (!!this._userDisconnected) return [3 /*break*/, 6];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, window.ethereum.request({
                                method: "eth_requestAccounts",
                            })];
                    case 4:
                        accounts = _a.sent();
                        newSelectedAddress = accounts[0];
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        if (!(newSelectedAddress != this._selectedAddress)) return [3 /*break*/, 11];
                        if (!(newSelectedAddress && this._ens)) return [3 /*break*/, 10];
                        _a.label = 7;
                    case 7:
                        _a.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, this._ens.reverse(newSelectedAddress)];
                    case 8:
                        newSelectedENSName = _a.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        error_2 = _a.sent();
                        return [3 /*break*/, 10];
                    case 10:
                        this._selectedAddress = newSelectedAddress;
                        this._selectedENSName = newSelectedENSName;
                        window.dispatchEvent(new Event(this.ADDRESS_CHANGED));
                        _a.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Call to request login from metamask
     */
    _EthereumProvider.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var metamaskProvider, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(!this._selectedAddress && !this._connecting)) return [3 /*break*/, 7];
                        this._userDisconnected = false;
                        return [4 /*yield*/, detect_provider_1.default({ mustBeMetaMask: true })];
                    case 1:
                        metamaskProvider = _c.sent();
                        if (!metamaskProvider) return [3 /*break*/, 6];
                        if (!metamaskProvider.isConnected()) {
                            throw new MetaMaskConnectionError();
                        }
                        if (!(this._browserProvider != metamaskProvider)) return [3 /*break*/, 4];
                        // Set up the chain state
                        this._browserProvider = metamaskProvider;
                        if (!this._browserProvider.isConnected()) return [3 /*break*/, 3];
                        _a = this;
                        _b = parseInt;
                        return [4 /*yield*/, window.ethereum.request({
                                method: "eth_chainId",
                            })];
                    case 2:
                        _a._browserChainId = _b.apply(void 0, [_c.sent()]);
                        _c.label = 3;
                    case 3:
                        this._addBrowserProviderListeners();
                        this._setProvider();
                        _c.label = 4;
                    case 4:
                        if (!this._browserProvider.isConnected()) return [3 /*break*/, 6];
                        // Trigger request to get wallet authentication if browser provider is connected
                        return [4 /*yield*/, this._handleEthereumAccountChange()];
                    case 5:
                        // Trigger request to get wallet authentication if browser provider is connected
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        this._connecting = false;
                        _c.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Call to logout
     */
    _EthereumProvider.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._selectedAddress = undefined;
                this._selectedENSName = undefined;
                this._userDisconnected = true;
                window.dispatchEvent(new Event(this.ADDRESS_CHANGED));
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns web3 instance
     */
    _EthereumProvider.web3 = function () {
        if (this._web3 === undefined) {
            if (this._provider === undefined) {
                throw new EthereumProviderNotFound("EthereumProvider not found");
            }
            this._web3 = new web3_1.default(this._provider);
        }
        return this._web3;
    };
    /**
     * @returns ENS instance
     */
    _EthereumProvider.ens = function () {
        if (this._ens === undefined) {
            throw new ENSProviderNotFound("ENSProvider not found");
        }
        return this._ens;
    };
    /**
     * @returns selected address (undefined if not logged in)
     */
    _EthereumProvider.selectedAddress = function () {
        return this._selectedAddress;
    };
    /**
     * @returns selected ENS name (undefined if not logged in)
     */
    _EthereumProvider.selectedENSName = function () {
        return this._selectedENSName;
    };
    /**
     * @returns the configured network if any
     */
    _EthereumProvider.network = function () {
        return this._network;
    };
    /**
     * @returns the chain ID of the connected network
     */
    _EthereumProvider.chainId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chainId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EthereumProvider.web3().eth.getChainId()];
                    case 1:
                        chainId = _a.sent();
                        return [2 /*return*/, chainId];
                }
            });
        });
    };
    /**
     * Returns true if:
     *    There is no detected browser chain
     *    There is no network specified
     *    You are connected and your browser provider is using the same chain as the network
     *
     * Primarily use this after you connect.
     * Use this to check a user is on the right chain for WRITE functions.
     * Use this to show a warning if they're on the wrong chain AND connected
     *
     * @returns chainIsCorrect: bool
     */
    _EthereumProvider.chainIsCorrect = function () {
        return !this._browserChainId || !this._network || this._browserChainId == this._network;
    };
    _EthereumProvider.ADDRESS_CHANGED = "ethereum-address-changed";
    _EthereumProvider.PROVIDER_CHANGED = "ethereum-provider-changed";
    _EthereumProvider.PROVIDER_CANT_CONNECT = "ethereum-provider-cant-connect";
    _EthereumProvider.PROVIDER_NOT_FOUND = "ethereum-provider-not-found";
    _EthereumProvider.CHAIN_CHANGED = "ethereum-provider-chain-changed";
    _EthereumProvider._provider = undefined;
    _EthereumProvider._ens = undefined;
    _EthereumProvider._browserProvider = undefined;
    _EthereumProvider._browserChainId = undefined;
    _EthereumProvider._fallbackProvider = undefined;
    _EthereumProvider._selectedAddress = undefined;
    _EthereumProvider._selectedENSName = undefined;
    _EthereumProvider._web3 = undefined;
    _EthereumProvider._connecting = false;
    // This variable is used to track user website disconnections and prevent auto reconnection when a user disconnects via the interface
    // then triggers a metamask disconnection (which would subsequently trigger a accountsChanged event)
    _EthereumProvider._userDisconnected = false;
    return _EthereumProvider;
}());
// Singleton instance
var EthereumProvider = _EthereumProviderSingleton();
exports.EthereumProvider = EthereumProvider;
// Instantiate EthereumProvider singleton
function _EthereumProviderSingleton() {
    if (!window.manifoldxyzEthereumProvider) {
        window.manifoldxyzEthereumProvider = _EthereumProvider;
    }
    return window.manifoldxyzEthereumProvider;
}
